import axios from 'axios'
import { LOGINAPI_ADDRESS } from 'config'
import { SuburbConfig } from 'config/constants/types'
import { TeamList } from 'state/types'

// console.log(LOGINAPI_ADDRESS)

export const getTeamListings = async (userId: string): Promise<TeamList[]> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const url = `${LOGINAPI_ADDRESS}/api/users/assign-work?userId=${tokenData._id}`
  const { data } = await axios.get(url, config)
  return data.propertyList
}

export const removeTeamListing = async (qaId: string, propertyId: string): Promise<any> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const url = `${LOGINAPI_ADDRESS}/api/users/assign-work`
  const { data } = await axios.delete(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
    data: {
      propertyId,
      qaId,
    },
  })
  return data
}

export const addTeamListing = async (
  userId: string,
  propertyId,
  qaId: string,
  shortName: string,
  qaName: string,
): Promise<any> => {
  // const propertyIds = { propertyId }
  // console.log(propertyIds)
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const url = `${LOGINAPI_ADDRESS}/api/users/assign-work`
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const { data } = await axios.post(url, { userId, propertyId, qaId, shortName, qaName }, config)

  return data
  // return propertyIds
}

export const sendToQa = async (propertyId: string, qaId: string, pData: string): Promise<any> => {
  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  const url = `${LOGINAPI_ADDRESS}/api/users/qa-work`
  const userId = tokenData._id
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenData.token}`,
    },
  }
  const { data } = await axios.post(url, { userId, propertyId, qaId, propertyData: pData }, config)

  return data
}
